import styled, { css } from 'styled-components/macro'

export const Wrapper = styled.div`
  width: 100%;
`

export const NomeSecao = styled.h1`
  ${({ theme }) => css`
    color: ${theme.colors.black};
    font-weight: ${theme.font.bold};
    font-size: ${theme.font.sizes.medium};
  `}
  margin-bottom: 16px;
`

export const SecaoOpcional = styled.span`
  ${({ theme }) => css`
    color: ${theme.colors.gray};
    font-size: ${theme.font.sizes.small};
    font-weight: ${theme.font.normal};
  `}
  margin-left: 6px;
`

export const ContainerFlex = styled.div`
  display: flex;
  margin: 0 0 0 4px;
`

export const CampoCheckbox = styled.div`
  margin: 0 48px 0 0;
`
